
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-copy/-embroider-implicit-modules.js";
